import type { JSX } from 'react';
import { Workflow, Wrench, ShieldCheck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { useReveal } from '@hooks/useReveal';
import { useContent } from '@data';
import { useT } from '@/i18n';
import type { Pillar } from '@data/fr/pillars';
import './Pillars.css';

const ICONS: Record<Pillar['icon'], LucideIcon> = {
  Workflow,
  Wrench,
  ShieldCheck,
};

export default function Pillars(): JSX.Element {
  const ref = useReveal();
  const { PILLARS } = useContent();
  const t = useT();

  return (
    <section className="Pillars" aria-labelledby="pillars-title">
      <div className="Pillars__inner reveal" ref={ref}>
        <p className="Pillars__label">{t.sections.pillars.title}</p>
        <h2 className="Pillars__title" id="pillars-title">
          {t.sections.pillars.heading}
        </h2>

        <div className="Pillars__grid">
          {PILLARS.map((pillar) => {
            const Icon = ICONS[pillar.icon];
            return (
              <article key={pillar.id} className={`Pillars__card Pillars__card--${pillar.accentClass}`}>
                <Icon className="Pillars__icon" aria-hidden="true" />
                <h3 className="Pillars__card-title">{pillar.title}</h3>
                <p className="Pillars__card-body">{pillar.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
